<div class="user-details-wrap cursor-pointer">
    <a routerLink="{{account?.link}}" class="pull-left pl-3 pr-3">
        <i class="sli-user ml-1 mr-1"></i>{{user?.username}}
    </a>
    <button spinEl
            [spinning]="submitSpinner"
            class="logout btn btn-sm btn-light pull-right"
            (click)="logout()"
            translate>
        <i class="sli-power m-1"></i>Logout
    </button>
</div>